var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbitiousStudentsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2995_2857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0566406,
    y: 0.308594,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2995_2857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05664 21.3086V19.3086H11.0566V16.2086C10.24 16.0253 9.51081 15.6794 8.86914 15.1711C8.22747 14.6628 7.75664 14.0253 7.45664 13.2586C6.20664 13.1086 5.16081 12.5628 4.31914 11.6211C3.47747 10.6794 3.05664 9.57526 3.05664 8.30859V7.30859C3.05664 6.75859 3.25247 6.28776 3.64414 5.89609C4.03581 5.50443 4.50664 5.30859 5.05664 5.30859H7.05664V3.30859H17.0566V5.30859H19.0566C19.6066 5.30859 20.0775 5.50443 20.4691 5.89609C20.8608 6.28776 21.0566 6.75859 21.0566 7.30859V8.30859C21.0566 9.57526 20.6358 10.6794 19.7941 11.6211C18.9525 12.5628 17.9066 13.1086 16.6566 13.2586C16.3566 14.0253 15.8858 14.6628 15.2441 15.1711C14.6025 15.6794 13.8733 16.0253 13.0566 16.2086V19.3086H17.0566V21.3086H7.05664ZM7.05664 11.1086V7.30859H5.05664V8.30859C5.05664 8.94193 5.23997 9.51276 5.60664 10.0211C5.97331 10.5294 6.45664 10.8919 7.05664 11.1086ZM12.0566 14.3086C12.89 14.3086 13.5983 14.0169 14.1816 13.4336C14.765 12.8503 15.0566 12.1419 15.0566 11.3086V5.30859H9.05664V11.3086C9.05664 12.1419 9.34831 12.8503 9.93164 13.4336C10.515 14.0169 11.2233 14.3086 12.0566 14.3086ZM17.0566 11.1086C17.6566 10.8919 18.14 10.5294 18.5066 10.0211C18.8733 9.51276 19.0566 8.94193 19.0566 8.30859V7.30859H17.0566V11.1086Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbitiousStudentsIcon);
export default __webpack_public_path__ + "static/media/ambitious-students-icon.def6fb12f950983f89b6bcda9b3651e3.svg";
export { ForwardRef as ReactComponent };